import { AccrualModelUnitName, QuantityMapKey } from "../enums";

export const HUMANIZED_QUANTITY_MAP_KEY: Record<QuantityMapKey, string> = {
  [QuantityMapKey.QUANTITY]: "Quantity",
  [QuantityMapKey.EMPTY]: "Quantity",
  [QuantityMapKey.WORK_DURATION]: "Duration (s)",
  [QuantityMapKey.WORK_DURATION_MS]: "Duration (ms)",
  [QuantityMapKey.WORK_RENDER_DURATION]: "Render duration (s)",
  [QuantityMapKey.WORK_SECONDS]: "Seconds",
  [QuantityMapKey.WORK_MILLISECONDS]: "Milliseconds",
  [QuantityMapKey.WORK_SYMBOLS_COUNT]: "Symbols count",
  [QuantityMapKey.WORK_WORDS_COUNT]: "Words count",
  [QuantityMapKey.WORK_TOTAL_SPENT_TIME]: "Total spent time (s)",
  [QuantityMapKey.WORK_TOTAL_AMOUNT]: "Total amount",
  [QuantityMapKey.WORK_UNITS_COUNT]: "Units count",
};

export const QUANTITY_MAP_KEY_TO_ACCRUAL_MODEL_UNIT_NAME: Record<
  Exclude<QuantityMapKey, QuantityMapKey.QUANTITY | QuantityMapKey.EMPTY>,
  AccrualModelUnitName
> = {
  [QuantityMapKey.WORK_DURATION]: AccrualModelUnitName.SECOND,
  [QuantityMapKey.WORK_DURATION_MS]: AccrualModelUnitName.MILLISECOND,
  [QuantityMapKey.WORK_RENDER_DURATION]: AccrualModelUnitName.SECOND,
  [QuantityMapKey.WORK_SECONDS]: AccrualModelUnitName.SECOND,
  [QuantityMapKey.WORK_MILLISECONDS]: AccrualModelUnitName.MILLISECOND,
  [QuantityMapKey.WORK_SYMBOLS_COUNT]: AccrualModelUnitName.CHAR,
  [QuantityMapKey.WORK_WORDS_COUNT]: AccrualModelUnitName.WORD,
  [QuantityMapKey.WORK_TOTAL_SPENT_TIME]: AccrualModelUnitName.SECOND,
  [QuantityMapKey.WORK_TOTAL_AMOUNT]: AccrualModelUnitName.AMOUNT,
  [QuantityMapKey.WORK_UNITS_COUNT]: AccrualModelUnitName.UNIT,
};
